var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5962_46074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.04825C11.7108 1.80038 10.871 1.66675 10 1.66675C5.39765 1.66675 1.66669 5.39771 1.66669 10.0001C1.66669 14.6025 5.39765 18.3334 10 18.3334C14.6024 18.3334 18.3334 14.6025 18.3334 10.0001C18.3334 8.57064 17.9734 7.22526 17.3393 6.04962M14.1667 4.79175H14.1709M8.75007 18.2403L8.75015 16.4042C8.75016 16.3047 8.78574 16.2086 8.85046 16.133L10.9219 13.7163C11.0922 13.5176 11.0394 13.2131 10.8123 13.0833L8.43213 11.7232C8.36746 11.6862 8.31388 11.6326 8.27697 11.5679L6.7254 8.84894C6.64465 8.70743 6.48883 8.62597 6.32655 8.64042L1.72017 9.0507M17.5 5.00008C17.5 6.84103 15.8334 8.33342 14.1667 10.0001C12.5 8.33342 10.8334 6.84103 10.8334 5.00008C10.8334 3.15913 12.3257 1.66675 14.1667 1.66675C16.0076 1.66675 17.5 3.15913 17.5 5.00008ZM14.375 4.79175C14.375 4.90681 14.2817 5.00008 14.1667 5.00008C14.0516 5.00008 13.9584 4.90681 13.9584 4.79175C13.9584 4.67669 14.0516 4.58341 14.1667 4.58341C14.2817 4.58341 14.375 4.67669 14.375 4.79175Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5962_46074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01);
export default __webpack_public_path__ + "static/media/globe-01.3c2666c1f649f1629a3839ccfdd4c89a.svg";
export { ForwardRef as ReactComponent };